import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { ListResultDTO } from "../../../helpers/listResult.interface copy";
import { CustomerDTO, CustomersFilters } from "../../models/customer";

@Injectable({
  providedIn: "root"
})
export class LaravelCustomerService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      show: environment.baseUrl + "/api/customers",
      list: environment.baseUrl + "/api/customers",
      store: environment.baseUrl + "/api/customers",
      destroy: environment.baseUrl + '/api/customers',
      report: environment.baseUrl + "/api/customers/report",
      updateNote: environment.baseUrl + "/api/customers/updateNote"
    };
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filter: CustomersFilters,
    // defaultTenantId?: number,
    includes?: string[],
  ): Observable<ListResultDTO<CustomerDTO>> {
    let params = {};

    if (page) params["page"] = "" + page;
    if (per_page) params["per_page"] = "" + per_page;
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filter) {
      if (filter.filter) params["filter"] = "" + filter.filter;
      if (filter.defaultTenantId) params["defaultTenantId"] = "" + filter.defaultTenantId;
    }

    if (per_page) {
      params['per_page'] = '' + per_page;
      if (page) params['page'] = '' + page;
      return this.httpClient.get<ListResultDTO<CustomerDTO>>(
        this.ROUTES.list,
        {
          params: new HttpParams({ fromObject: params }),
        }
      );
    } else {
      return this.httpClient
        .get<CustomerDTO[]>(this.ROUTES.list, {
          params: new HttpParams({ fromObject: params }),
        })
        .pipe(
          map((results) => {
            return {
              data: results,
              total: results.length,
            };
          })
        );
    }

    // return this.httpClient.get(this.ROUTES.list, {
    //   params: new HttpParams({ fromObject: params })
    // });
  }

  // public getById(id: number): Observable<any> {
  //   return this.httpClient.get(this.ROUTES.show, {
  //     params: new HttpParams({ fromObject: { id: "" + id } })
  //   });
  // }

  public show(id: number): Observable<CustomerDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<CustomerDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params,
      }),
    });
  }

  // public create(formData: FormData) {
  //   return this.httpClient.post(this.ROUTES.store, formData);
  // }

  // public create(name: string, surname: string, phone: string, email: string, notes: string, active: boolean) {
  //   let customer = {
  //     name: name,
  //     surname: surname,
  //     phone: phone,
  //     email: email,
  //     notes: notes,
  //     active: active,
  //   };
  //   return this.httpClient.post(this.ROUTES.store, { customer: customer });
  // }

  // public update(id: number, name: string, surname: string, phone: string, email: string, notes: string, active: boolean, fidelity_card_points: number, defaultTenantId: number, user_roles: string[]) {
  //   const customer = {
  //     id: id,
  //     name: name,
  //     surname: surname,
  //     phone: phone,
  //     email: email,
  //     notes: notes,
  //     active: active,
  //     fidelity_card_points: fidelity_card_points,
  //     default_tenant_id: defaultTenantId,
  //     // user_roles: [
  //     //   "customer"
  //     // ]
  //   };
  //   return this.httpClient.put(this.ROUTES.store + "/" + id, { ...customer });
  // }

  public upsert(customer: CustomerDTO): Observable<CustomerDTO> {
    if (customer.id) {
      return this.httpClient.put<CustomerDTO>(`${this.ROUTES.store}/${customer.id}`, {
        ...customer,
      });
    } else {
      return this.httpClient.post<CustomerDTO>(`${this.ROUTES.store}`, {
        ...customer,
      });
    }
  }



  public delete(id: number) {
    let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
  }

  public report(id, report) {
    return this.httpClient.post(this.ROUTES.report, {
      id: id,
      report: report
    });
  }

  public updateNote(id, notes) {
    return this.httpClient.put(this.ROUTES.updateNote, {
      id: id,
      notes: notes
    });
  }
}
